/**
 * Shared field validation limits, reused by every yup schema (guardian / player /
 * coach) and by the `maxLength` of their inputs so the two never drift apart.
 */

/** First / last / parent name fields. */
export const MAX_NAME_LENGTH = 100;
/** Email address. */
export const MAX_EMAIL_LENGTH = 100;
/** City. */
export const MAX_CITY_LENGTH = 100;
/** Street address line 1 / 2. */
export const MAX_STREET_ADDRESS_LENGTH = 200;
/** Zip / postal code. */
export const MAX_ZIP_LENGTH = 15;
/** Player height entry (1–2 digits + optional inch mark, e.g. `48"`). */
export const MAX_HEIGHT_LENGTH = 3;
/** Phone number input (typed characters, incl. country code + formatting). */
export const MAX_PHONE_LENGTH = 24;

/** Valid phone number digit count (excludes country code formatting). */
export const PHONE_MIN_DIGITS = 10;
export const PHONE_MAX_DIGITS = 24;

/** Avatar / photo upload cap (10 MB), shared across the guardian + player flows. */
export const MAX_AVATAR_FILE_SIZE = 10 * 1024 * 1024;

/** Email format. */
export const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
/** Player height: 1–2 digits with an optional trailing inch mark (`48"`). */
export const HEIGHT_INCHES_PATTERN = /^\d{1,2}"?$/;
